import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PaiementAmexBlackIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M21.9909 13.5951L20.4552 15.2133L21.9909 16.8497V13.5951Z"
				fill="currentColor"
			/>
			<path
				d="M2 1.99512V21.9951H21.9909V18.8224H19.5829L18.338 17.4497L17.0931 18.8224H9.14221V12.4224H6.57974L9.76011 5.2133H12.8314L13.9309 7.68603V5.2133H17.7292L18.3925 7.07694L19.0559 5.2133H22V1.99512H2Z"
				fill="currentColor"
			/>
			<path
				d="M21.9909 5.99512H19.6374L18.3744 9.49512L17.1295 5.99512H14.7306V11.6133H16.2481V7.68603L17.6838 11.6133H19.0377L20.4734 7.67694V11.6133H21.9909V5.99512Z"
				fill="currentColor"
			/>
			<path
				d="M21.9909 12.4224H20.01L18.3653 14.2224L16.7388 12.4224H14.7306L17.3748 15.2315L14.7306 18.0406H16.6842L18.338 16.2224L19.9827 18.0406H21.9909L19.3285 15.2133L21.9909 12.4224Z"
				fill="currentColor"
			/>
			<path
				d="M12.259 5.99512H10.2871L7.80645 11.6042H9.48751L9.95093 10.486H12.5316L13.0041 11.6042H14.7306L12.259 5.99512ZM10.4871 9.23148L11.2503 7.39512L12.0136 9.23148H10.4871Z"
				fill="currentColor"
			/>
			<path
				d="M14.7306 12.4224H9.95093V18.0406H14.7306V16.7406H11.4866V15.8678H14.6488V14.5951H11.4866V13.7224H14.7306V12.4224Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PaiementAmexBlackIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PaiementAmexBlackIcon;
